import React, { Component } from 'react';

import './ProductModel.css';

import { __ } from './../Translator';
import { thronImageUrl } from './../Helpers';
import Modal from './Modal';
import InlineSvg from "../InlineSvg";

import PlusRoundedIcon from './../img/plus-circled-icon.svg';
import GenderMaleIcon from './../img/gender-male-icon.svg';
import GenderFemaleIcon from './../img/gender-female-icon.svg';

import CheckIcon from './../img/check-solid.svg';
import TimesIcon from './../img/times-solid.svg';
import InfoIcon from "./../img/info.svg";

import LeatherKangarooIcon from './../img/leather-kangaroo-icon.svg';
import LeatherCowhideIcon from './../img/leather-cowhide-icon.svg';

import currencySymbol from '../utils/currencySymbol';
import isProductAvailableInUSCanada from '../utils/isProductAvailableInUSCanada';
import shouldShowPrice from '../utils/shouldShowPrice';
import CountryStore from '../flux/CountryStore';
import CountriesStore from '../flux/CountriesStore';

class ProductModel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      country: CountriesStore.find(CountryStore.getState()),
      isModalVisible: false,
      isSelected: props.isSelected,
    };

    this.genderIcons = {
      M: GenderMaleIcon,
      F: GenderFemaleIcon,
    };

    this.leatherIcons = {
      kangaroo: LeatherKangarooIcon,
      cowhide: LeatherCowhideIcon,
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      isSelected: nextProps.isSelected,
    });
  }

  onSelectClick() {
    this.setState({ isModalVisible: false });
    this.props.onSelectClick(this.props.product);
  }



  render() {
    // @todo 2017-09-13 Extract or improve how the image is given the correct size
    return (
      <div className="productModelContainer">
        <div className='productModel'>
          <div className="productModel__image" style={{ backgroundImage: `url(${thronImageUrl(this.props.product.default_color.preview_image_url, '', 350)})`, }} onClick={() => this.onSelectClick()} >
              <button className="muted icon icon-detail"
                      onClick={(event) => {
                        event.stopPropagation();
                        this.setState({ isModalVisible: true })
                      } }>
                <InlineSvg svg={InfoIcon} />
              </button>
          </div>

          <div className="productModel__name">
            <div className="u-ta-center">
            {this.props.product.name}
            </div>
            <div className="u-ta-center meta__details">
              <div className="meta__price">
                {shouldShowPrice(CountryStore.getState()) ? parseFloat(this.props.product.base_price).toLocaleString(undefined, {minimumFractionDigits: 2}) +" "+currencySymbol() : '-' }
              </div>
              {this.props.product.custom_fit === 1 ? (
                <div className="meta__storeonly">
                  {__('In-store only')}
                </div>
              ) : ""}
            </div>
            </div>

          <div className="productModel__meta">
            <div className="availability_head">
                 <span>{__('Available for:')}</span>
            </div>
            <div className="availability_container">
              <div className="">
                  <div className={"productModel__available__type "+(this.props.product.custom_fit === 1 ? "disabled" : "")}>
                      <InlineSvg className="productModel__available__icon" svg={this.props.product.custom_fit === 1 ? TimesIcon : CheckIcon} />{__('Standard fit')}
                  </div>
                  <div className={"productModel__available__type "+(this.props.product.custom_fit === 0 || this.state.country.online_purchase === 1 ? "disabled" : "")}>
                     <InlineSvg className="productModel__available__icon" svg={this.props.product.custom_fit === 0 || this.state.country.online_purchase === 1 ? TimesIcon : CheckIcon} />{__('Custom fit')}
                  </div>
              </div>
              <div className="">
                  <div className={"productModel__available__type "+(this.props.product.custom_color === 1 || this.state.country.online_purchase === 1 ? "disabled" : "")}>
                     <InlineSvg className="productModel__available__icon" svg={this.props.product.custom_color === 1 || this.state.country.online_purchase === 1 ? TimesIcon : CheckIcon} />{__('Standard color')}
                  </div>
                  <div className={"productModel__available__type "+(this.props.product.custom_color === 0 ? "disabled" : "")}>
                      <InlineSvg className="productModel__available__icon" svg={this.props.product.custom_color === 0 ? TimesIcon : CheckIcon} />{__('Custom color')}
                  </div>
              </div>
            </div>
          </div>
          <div className="productModel__select">
            <button className="btn btn-primary" onClick={() => this.onSelectClick()}>{__('Select')}</button>
          </div>

          <p className="productModel__notAvailableText">
            {isProductAvailableInUSCanada(this.props.product) ? " " : "Not available in US and Canada"}
          </p>
        </div>

        <Modal
          noFooterPadding={true}
          visible={this.state.isModalVisible}
          onCloseClick={() => this.setState({ isModalVisible: false })}
          actions={<button type="button" className="btn btn-primary btn-next" onClick={() => this.onSelectClick()}>{__('Select')}</button>}
        >
          <div className="productModel__detail">
            <div className="row">
              <div className="col-sm-5 u-ta-center">
                <img src={thronImageUrl(this.props.product.default_color.preview_image_url, '', 350)} alt="" />
              </div>
              <div className="col-sm-7">
                <h1 className="u-mt-0 u-fs-italic u-tt-uppercase">{this.props.product.name}</h1>

                <p>
                  <span className="u-tt-uppercase">{__(this.props.product.gender)} </span>/
                  <span className="u-tt-uppercase"> {__(this.props.product.leather)}</span>
                </p>
                <div className="u-mt-20" />
                <div className="modal--ProductDetail" dangerouslySetInnerHTML={{ __html: this.props.product.detail_text}} />
                {this.props.product.short_tall && (
                  <div>
                    <div className="u-mt-20" />
                    <div className="u-tt-uppercase" dangerouslySetInnerHTML={{ __html: __('Available in short and tall sizes')}} />
                  </div>
                  )}
              </div>

            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

export default ProductModel;



// WEBPACK FOOTER //
// ./src/components/ProductModel.js